import React, { useState, useEffect } from "react";
import Gallery from 'react-image-gallery'; // Import the gallery component
import 'react-image-gallery/styles/css/image-gallery.css';
import { useParams } from "react-router-dom";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
import BookingModal from "../../Components/BookingModal";
function EProductDetail() {
    const [data, setData] = useState([]);
    const [imagesList, setImagesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    useEffect(() => {
        const fetchApiData = async () => {
            const url = "api/electronic/specification/" + id;
            const result = await fetchData(url);
            if (result && result.data) {
                const images = result.data.media.map(item => ({
                    original: item.original_url,
                    thumbnail: item.original_url
                }));
                setImagesList(images)
                setData(result.data);
            }
            setLoading(false);
        };
        fetchApiData();
    }, [id]);
    const responsive = [
        {
            breakpoint: 1024, // Tablets and large mobile devices
            settings: {
                slidesToShow: 3,  // Display 3 images at a time on medium screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768, // Small devices (e.g. mobile phones)
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on mobile screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480, // Very small screens
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on very small screens
                slidesToScroll: 1,
            },
        },
    ];
    return (
        <div className="container my-5">

            {loading && <MainLoader />}
            <div className="mt-4">
                {/* Modern Header */}
                <div className="brand-banner py-5 px-3 text-center text-white mb-4">
                    <h1 className="display-4 fw-bold mb-2"><span className="brand-name">{data?.title}</span></h1>
                    <p className="lead">{data?.short_description}</p>
                </div>
            </div>
            <div className="row mt-3 bg-light p-2">
                <div className="col-md-12 p-2 text-center">
                    <img className="w-75" src={data?.media ? data.media[0]?.original_url : ''} />
                </div>
            </div>
            <div className="mt-5 varient-detail">

                <div class="title-wrapper d-flex mb-30">
                    <h4 class="mb-0 flex-shrink-0"> Specifications</h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Product Name</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.product_name}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Product Type</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.product_type}</p>
                                    </div>
                                </td>
                            </tr>


                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Certification</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.certification}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Color Options</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.color_option}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Connectivity Option</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.connectivity_option}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Control Type</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.control_type}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Country/Origin</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.country_of_origin}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Dimension</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.dimension}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Display</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.display}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Energy Rating</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.energy_rating}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Frequency</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.frequency}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Function</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.function}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Included Accessory</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.included_accessory}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Material</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.material}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Weight</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.weight}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Model Number</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.model_number}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Noise Level</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.noise_level}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Operating Temperature</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.operating_temperature}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Power Consumption</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.power_consumption}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Safety Feature</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.safety_feature}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Voltage Requirement</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.voltage_requirement}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Warranty</p>
                                        <p className="pb-0 mb-0">{data.electronicspecification?.warranty}</p>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div> */}
                <div className="teble-td-inherit mt-3">
                    <div className="row g-3">

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Product Name</p>
                                <p className="mb-0">{data.electronicspecification?.product_name}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Product Type</p>
                                <p className="mb-0">{data.electronicspecification?.product_type}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Certification</p>
                                <p className="mb-0">{data.electronicspecification?.certification}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Color Options</p>
                                <p className="mb-0">{data.electronicspecification?.color_option}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Connectivity Option</p>
                                <p className="mb-0">{data.electronicspecification?.connectivity_option}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Control Type</p>
                                <p className="mb-0">{data.electronicspecification?.control_type}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Country/Origin</p>
                                <p className="mb-0">{data.electronicspecification?.country_of_origin}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Dimension</p>
                                <p className="mb-0">{data.electronicspecification?.dimension}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Display</p>
                                <p className="mb-0">{data.electronicspecification?.display}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Energy Rating</p>
                                <p className="mb-0">{data.electronicspecification?.energy_rating}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Frequency</p>
                                <p className="mb-0">{data.electronicspecification?.frequency}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Function</p>
                                <p className="mb-0">{data.electronicspecification?.function}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Included Accessory</p>
                                <p className="mb-0">{data.electronicspecification?.included_accessory}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Material</p>
                                <p className="mb-0">{data.electronicspecification?.material}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Weight</p>
                                <p className="mb-0">{data.electronicspecification?.weight}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Model Number</p>
                                <p className="mb-0">{data.electronicspecification?.model_number}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Noise Level</p>
                                <p className="mb-0">{data.electronicspecification?.noise_level}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Operating Temperature</p>
                                <p className="mb-0">{data.electronicspecification?.operating_temperature}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Power Consumption</p>
                                <p className="mb-0">{data.electronicspecification?.power_consumption}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Safety Feature</p>
                                <p className="mb-0">{data.electronicspecification?.safety_feature}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Voltage Requirement</p>
                                <p className="mb-0">{data.electronicspecification?.voltage_requirement}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                                <p className="mb-0" style={{ color: 'gray' }}>Warranty</p>
                                <p className="mb-0">{data.electronicspecification?.warranty}</p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="mt-4 d-flex justify-content-between">
                    <BookingModal ProductDetail={data} />
                    <h3>Price : {data?.price}</h3>
                </div>
            </div>
        </div>
    )
}

export default EProductDetail;